function RangeBar(props){
    return <>
            {/*selector*/}
            {props.titles.map(title =>{
                return <div className="w-full gap-2 p-8 mx-auto mt-4 border-2 border-gray-100 rounded-3xl">
                    <p className="text-lg font-bold text-center">{title}</p>
                    <input type="range" min="0" max="100"  className="w-full range-line" step="25" />
                    <div className="flex justify-between w-full px-2 text-xs">
                        <svg width="8" height="8" viewBox="0 0 4 8" className="text-primary-500" fill="currentColor"  xmlns="http://www.w3.org/2000/svg">
                            <rect width="4" height="8" rx="2" fill="currentColor" />
                        </svg>
                        <svg width="8" height="8" viewBox="0 0 4 8" className="text-primary-500" fill="currentColor"  xmlns="http://www.w3.org/2000/svg">
                            <rect width="4" height="8" rx="2" fill="currentColor" />
                        </svg>
                        <svg width="8" height="8" viewBox="0 0 4 8" className="text-primary-500" fill="currentColor"  xmlns="http://www.w3.org/2000/svg">
                            <rect width="4" height="8" rx="2" fill="currentColor" />
                        </svg>
                        <svg width="8" height="8" viewBox="0 0 4 8" className="text-primary-500" fill="currentColor"  xmlns="http://www.w3.org/2000/svg">
                            <rect width="4" height="8" rx="2" fill="currentColor" />
                        </svg>
                        <svg width="8" height="8" viewBox="0 0 4 8" className="text-primary-500" fill="currentColor"  xmlns="http://www.w3.org/2000/svg">
                            <rect width="4" height="8" rx="2" fill="currentColor" />
                        </svg>

                    </div>
                    <div className="flex justify-between min-w-full py-1">
                            <div className="text-gray-800 ">Not All</div>
                            <div className="text-gray-800 ">A lot</div>
                    </div>
                </div>
            })}

    </>
}

export default RangeBar;